import { update, init } from "./State.fs.js";
import { view } from "./View.fs.js";
import { Page, Model__get_Headline } from "./Types.fs.js";
import { PageHeader } from "../../../Bfs.Web.Portale/Types.fs.js";
import { singleton, tail, head, isEmpty } from "../../fable_modules/fable-library-js.4.19.0/List.js";
import { WebPart$3 } from "../../../Bfs.Web.Portale/WebPart.fs.js";

export const Part = new WebPart$3(init, update, view, (model_2) => (new PageHeader(1, [Model__get_Headline(model_2)])), (_arg_2) => (!isEmpty(_arg_2) ? ((head(_arg_2) === "impressum") ? (isEmpty(tail(_arg_2)) ? (new Page(1, [])) : undefined) : ((head(_arg_2) === "datenschutz") ? (isEmpty(tail(_arg_2)) ? (new Page(0, [])) : undefined) : undefined)) : undefined), (_arg_1) => {
    if (_arg_1.tag === 0) {
        return singleton("datenschutz");
    }
    else {
        return singleton("impressum");
    }
}, (_arg) => undefined);

//# sourceMappingURL=WebPart.fs.js.map
